import { render, staticRenderFns } from "./InscritDetail.vue?vue&type=template&id=9ad4cf38&"
import script from "./InscritDetail.vue?vue&type=script&lang=js&"
export * from "./InscritDetail.vue?vue&type=script&lang=js&"
import style0 from "./InscritDetail.vue?vue&type=style&index=0&id=9ad4cf38&prod&media=screen&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports